import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeleteData } from 'src/app/core/models/storage-data-type';

@Component({
  selector: 'app-delete-confirm',
  templateUrl: './delete-confirm.component.html',
  styleUrls: ['./delete-confirm.component.scss']
})
export class DeleteConfirmComponent implements OnInit {

  includesFolder: boolean = this.data.every(d => d.type == 'file') ? false : true;
  type: string;
  name: string = "";
  store: string;
  constructor(
    public dialog: MatDialogRef<DeleteConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteData[]
  ) {}

  ngOnInit(){
    let newData = this.data.map(x => x.name);
    if(newData.length > 5){
      newData = newData.slice(0, 5);
      this.name = ` + ${this.data.length - 5} other items.`;
    }
    this.name = newData.join(", ") + this.name;
    this.store = this.data[0].store
  }

  onClose(){
    this.dialog.close(false)
  }
}
